import { ReasonForNegativeScore } from "./QaScore.model";

export const reasonsForNegativeScoreFormatted: Record<
  ReasonForNegativeScore,
  string
> = {
  poor_active_listening: "Poor active listening",
  repetitive_questions: "Repetitive questions",
  inconsistent_information: "Inconsistent information",
  language_barriers: "Language barriers",
  missed_to_ask_clarifying_question: "Missed to ask clarifying question",
  rushed_responses: "Rushed responses",
  lack_of_empathy: "Lack of empathy",
  failure_to_acknowledge_mistake: "Failure to acknowledge mistake",
  long_wait_times: "Long wait times",
  lack_of_confidence: "Lack of confidence",
  inability_to_address_urgency: "Inability to address urgency",
  impersonal_interactions: "Impersonal interactions",
  unresponsive: "Unresponsive",
  not_getting_to_the_point: "Not getting to the point",
  lack_of_customer_education: "Lack of customer education",
  inadequate_follow_up: "Inadequate follow-up",
  inaccurate_promises: "Inaccurate promises",
  missed_to_set_proper_expectations: "Missed to set proper expectations",
  invalid_escalations: "Invalid escalations",
  no_thorough_investigation: "No thorough investigation",
  lack_of_product_knowledge_expertise: "Lack of product knowledge expertise",
  faild_to_confirm_resolution: "Failed to confirm resolution",
  unresolved_issues: "Unresolved issues",
};
